import throttle from '../base/_throttle.js';

export default class Header {
    constructor(node = '.masthead', opts = {}) {
        this.node = typeof node === 'string' ? document.querySelector(node) : node;

        if (!(this.node instanceof HTMLElement)) {
            return;
        }

        this.opts = Object.assign(
            {
                search: '.masthead__search',
                menu: '.masthead__menu',
                submenu: {
                    menu: 'nav__menu',
                    parent: 'nav__menu-item--has-children',
                    visible: 'nav__menu--visible',
                    visibleClass: '.nav__menu--visible',
                }
            },
            opts
        );

        let lastScrollPosition = window.scrollY;
        let isPinned = false;
        let isScrolled = false;

        const checkThreshold = () => {
            // Check if the element has the class 'masthead-lite'
            if (this.node.classList.contains('masthead-lite')) {
                return;
            }

            const scrollY = window.scrollY;
            const height = this.node.offsetHeight;

            if (window.innerWidth >= 992) {
                if (scrollY === 0) {
                    this.node.classList.remove('masthead--not-top');
                    this.node.classList.add('masthead--top');
                    this.node.classList.remove('masthead--pinned');
                } else {
                    this.node.classList.remove('masthead--not-top');
                    this.node.classList.add('masthead--not-top');
                    this.node.classList.add('masthead--pinned');
                }

                return;
            }

            const isScrollingUp = scrollY < lastScrollPosition;

            if (scrollY === 0) {
                this.node.classList.remove('masthead--not-top');
                isPinned = false;
                isScrolled = false;
                document.documentElement.style.paddingTop = '';
                this.node.classList.remove('masthead--pinned', 'masthead--unpinned');
            } else if (scrollY > 100 && isScrollingUp && isPinned) {
                this.node.classList.add('masthead--not-top');
                isPinned = false;
                document.documentElement.style.paddingTop = '';
                this.node.classList.remove('masthead--pinned');
                this.node.classList.add('masthead--unpinned');
            } else if (!isScrollingUp && !isPinned) {
                this.node.classList.add('masthead--not-top');
                isPinned = true;
                isScrolled = true;
                //document.documentElement.style.paddingTop = `${height}px`;
                this.node.classList.remove('masthead--unpinned');
                this.node.classList.add('masthead--pinned');
            }

            lastScrollPosition = scrollY;
        };

        const checkScreenWidth = () => {
            if (window.innerWidth < 992) {
                this.node.classList.add('masthead--mobile');
            } else {
                this.node.classList.remove('masthead--mobile');
            }
        };

        window.addEventListener('scroll', throttle(checkThreshold, 350));
        window.addEventListener('DOMContentLoaded', checkThreshold);
        window.addEventListener('resize', throttle(checkScreenWidth, 350));
        window.addEventListener('DOMContentLoaded', checkScreenWidth);

        this.search = typeof this.opts.search === 'string' ? this.node.querySelectorAll(this.opts.search) : this.opts.search;
        this.hamburger = typeof this.opts.menu === 'string' ? this.node.querySelector(this.opts.menu) : this.opts.menu;

        const parents = Array.from(this.node.querySelectorAll(`.${this.opts.submenu.parent}`));

        parents.forEach(parent => {
            const links = Array.from(parent.children).filter(n => n.matches('.nav__link'));

            if (!links.length) {
                return;
            }

            const link = links.shift();

            link.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                parent.classList.toggle(this.opts.submenu.visible);

                const linkParents = [];
                let parentNode = link.parentNode;

                while (parentNode && parentNode.parentNode) {
                    linkParents.push(parentNode);
                    parentNode = parentNode.parentNode;
                }

                parents.filter(p => p !== parent && !linkParents.includes(p)).forEach(p => {
                    p.classList.remove(this.opts.submenu.visible);
                });
            });
        });

        this.node.addEventListener('mouseleave', () => {
            parents.forEach(parent => parent.classList.remove(this.opts.submenu.visible));
        });
    }
}
